const formatCampo = (value) => {
  const modalidades = {
    administracion: "Administración",
    ciencias_naturales_matematicas_y_estadistica: "Ciencias Naturales, Matemáticas y Estadística",
    hibrida: "Híbrida",
  };

  if (modalidades[value]) return modalidades[value];

  // fallback automático
  return value
    ?.replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

const Campo = ({ value }) => {
  if (!value) return null;

  return (
    <p>
     {formatCampo(value)}
    </p>
  );
};

export default Campo;